import _ from 'underscore';

export function processSharedFields(fields, shared) {
  return _.mapObject(fields, (field) => {
    const fieldSchema = field.$schema || '';
    const sharedSchema = _.result(shared, fieldSchema.replace('shared/filters/', ''));

    return sharedSchema;
  });
}
